<template>
	<page-body>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-left:10px; padding-top:10px; padding-bottom:0px;">
      <el-form :inline="true" >
        <el-row :gutter="24">
        <el-col :span="10">
              <el-form-item label="起始日期:" >
                <el-date-picker v-model="startDate" type="date" placeholder="选择日期"  ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="终止日期:" >
                <el-date-picker v-model="endDate" type="date" placeholder="选择日期"  ></el-date-picker>
              </el-form-item>
            </el-col>
                     </el-row>
      </el-form>
            <el-form :inline="true" >
        <el-row :gutter="24">
            <el-col :span="10">
          <el-select multiple  style='margin-bottom:20px;width:100%'  v-model="name" filterable="" clearable remote placeholder="请输入商品名称" :remote-method="remoteMethod" >
                  <el-option v-for="item in items" :key="item.key" :label="item.label" :value="item.key">
                  </el-option>
              </el-select>
      </el-col>
			<el-col :span="2">
		 	<el-button style='float:right' type="primary" icon="search" @click="getPurchases()"></el-button>
		 	</el-col>
		 	<el-col :span="2">
		 	<el-button style='float:left' type="primary" icon="document" @click="handleDownload">导出excel</el-button>
		 	</el-col>
		 </el-row>
      </el-form>
      </el-col>

		<!--列表-->
		<el-table :data="purchases" border stripe :search-def='getSearchDef()' highlight-current-row v-loading="listLoading" @selection-change="selsChange" @row-dblclick="rowDblclick" style="width: 100%;">
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="itemNo" label="商品编号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="itemName" label="商品名称" width="180" sortable>
			</el-table-column>
			<el-table-column prop="spec" label="商品规格" min-width="150" sortable>
			</el-table-column>
			<el-table-column prop="manufacture" label="生产厂家" min-width="210"  sortable>
			</el-table-column>
			<el-table-column prop="unit" label="单位" width="70">
			</el-table-column>
			<el-table-column prop="purchaseQty" label="采购数量" width="120" sortable>
			</el-table-column>
      <el-table-column prop="price" label="含税单价" width="100" v-if="userInfo.showMoney" >
      </el-table-column>
      <el-table-column prop="number" label="含税金额" width="100" v-if="userInfo.showMoney" >
      </el-table-column>
			<el-table-column prop="batchNo" label="批号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="expiryDate" label="有效日期" width="120" sortable>
			</el-table-column>
			<el-table-column prop="supplierName" label="供应商名称" min-width="210" sortable>
			</el-table-column>
			<el-table-column prop="stockDate"   label="入库日期" width="120"  sortable>
			</el-table-column>
       <el-table-column prop="department" label="部门" width="100" >
      </el-table-column>

		</el-table>
			<!--工具条-->
		<el-col :span="24" class="toolbar">

			<el-pagination style="float:right;"
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="page"
		      :page-sizes="[5, 10, 15, 20]"
		      :page-size="pageSize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
		</el-col>

	</page-body>

</template>

<script>
	//import NProgress from 'nprogress'
	import { webapi, HTTP} from '../../api/api';
	import util from '../../common/js/util';
	import { export_json_to_excel } from '../../vendor/Export2Excel';
	export default {
		data() {
			return {
        startDate:new Date()- 3600 * 1000 * 24,
        endDate: new Date(),
				name: [],
				pageSize:15,
				purchases: [],
				items:[],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列
        userInfo:{}
			}
		},
		methods: {
      getUserInfo(){
        var vm = this;
        webapi.post('/user/getUserInfo', {}).then((res)=>{
          vm.userInfo = res.data
        })
      },
			handleDownload() {
				var vm = this;
				let para = {
				};
				para.startTime = util.formatDate.format(new Date(vm.startDate), 'yyyy-MM-dd')
        para.endTime = util.formatDate.format(new Date(vm.endDate), 'yyyy-MM-dd')
				var uploadName = '';
				for(var i = 0; i <vm.name.length; i++){
					uploadName+= vm.name[i]+','
				}
				para.name =uploadName;
				webapi.post('/purchase/findAll', para)
				  .then(function(response) {
				  	require.ensure([], () => {
			        const tHeader = ['序号', '商品编号', '商品名称', '商品规格', '生产厂家','单位','采购数量','含税单价','含税金额','批号','有效日期','供应商名称','入库日期'];
			        const filterVal = ["id","itemNo","itemName","spec","manufacture","unit","purchaseQty",'price',"number","batchNo","expiryDate","supplierName","stockDate"];
			        const list = response.data;
			        const data = vm.formatJson(filterVal, list);
			        export_json_to_excel(tHeader, data, '采购流向表');
			      })
				 }).catch((error) => {
				    vm.$message.error(error.response.data['message']);
				});

		    },
		    formatJson(filterVal, jsonData) {
		      return jsonData.map(v => filterVal.map(j => v[j]))
		    },
			remoteMethod(query) {
	          	var vm = this;
	            let para = {
                params:{
                  offset: (vm.page-1)*vm.pageSize,
                  max: 500,
                  "queryParams": query,
                  "query":"itemName"
                }
              };
	            webapi.get('/item', para)
	            .then(function(response) {
	               //console.log(response.data.results)
	               vm.list = response.data.map(item => {
	                        return {key:item.id,value:item.itemName, label:item.itemNo+" "+item.itemName+" "+item.spec};
	                      });

	              vm.loading = false;
	              vm.items = vm.list
	            }).catch((error) => {
	            	vm.loading = false;
				    vm.$message.error(error.response.data['message']);
				});

        },
			// formatter: function (row, column) {
	  //     		return util.formatDate.format(row.salesDate, 'yyyy-MM-dd');
			// },
			handleSizeChange(val) {

				this.pageSize = val
				this.getPurchases();
				// this.getBranchWarehouse();
	        	// console.log(`每页 ${val} 条`);
	      	},
			handleCurrentChange(val) {
				this.page = val;
				this.getPurchases();
			},
			getSearchDef() {
			      return {
			        offset: 12,
			        placeholder: 'please input searchkey'
			        //,
			        //props: ['state', 'flow_type'] // can be string or Array
			      }
			    },
			getPurchases() {
          var vm = this;
        let para = {
          params:{
            offset: (vm.page-1)*vm.pageSize,
            max: vm.pageSize
          }
        };
        vm.listLoading = true;
        //NProgress.start();
        para.params.startTime = util.formatDate.format(new Date(vm.startDate), 'yyyy-MM-dd')
        para.params.endTime = util.formatDate.format(new Date(vm.endDate), 'yyyy-MM-dd')
        var uploadName = '';
        for(var i = 0; i <vm.name.length; i++){
          uploadName+= vm.name[i]+','
        }
        para.params.name =uploadName;
        webapi.get('/purchase', para)
          .then(function(response) {
            if (response.data=="nopermission") {
              vm.$notify({
                  title: '警告',
                  message: '您的账户已到期,请联系管理员.',
                  type: 'warning'
                });
            }else{
              vm.total = response.data.total;
              vm.purchases = response.data.results;
            }
            vm.listLoading = false;
         }).catch((error) => {
          vm.listLoading = false;
            vm.$message.error(error.response.data['message']);
        });
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			rowDblclick:function(row, event){
				console.log(row)
			}
		},
		mounted() {
      this.getUserInfo()
			this.getPurchases();
			this.remoteMethod('');
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PurchaseTable.vue?86da4776